import { defineMessages } from 'react-intl';
import { SportTermLookup, SportTerminology } from '../../../lib/types';

export const scope = 'app.components.AssessmentSessionPlayerList';

export const getMessages = (termLookup: SportTermLookup) => {
  const session = termLookup[SportTerminology.SESSION].toLowerCase();
  return defineMessages({
    errRosterNotLoaded: {
      id: `${scope}.errRosterNotLoaded`,
      defaultMessage: `The ${session} roster couldn't be loaded. Refresh the page to try again.`
    },
    emptyRoster: {
      id: `${scope}.emptyRoster`,
      defaultMessage: 'None'
    }
  });
};
